export enum APP_PAGES {
  SEARCH = "/search",
  CUSTOMER_DETAILS = "/:name",
  RESOURCES = "/resources",
  // Document routes
  DOCS = "/documents",
  DOCS_LIBRARY = "/documents/library",
  DOCS_UPLOAD = "/documents/upload",
  DOCS_DETAIL = "/documents/:id",
}
